var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.mode == "edit"
        ? _c("el-input", {
            attrs: {
              min: "0",
              max: "100",
              placeholder: _vm.placeholder,
              "data-bot": _vm.dataBot
            },
            on: { change: _vm.update, blur: _vm.formatAmount },
            scopedSlots: _vm._u(
              [
                {
                  key: "append",
                  fn: function() {
                    return [_vm._v("%")]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              73834678
            ),
            model: {
              value: _vm.currentValue,
              callback: function($$v) {
                _vm.currentValue = $$v
              },
              expression: "currentValue"
            }
          })
        : _c("p", [_vm._v(_vm._s(_vm.currentValue) + " %")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }